import { combineReducers } from 'redux';

import Modal from './modal';
import Loading from './loading';
import TT from './tt';
import message from './message';
import Config from './config';

export default combineReducers({
  Config,
  TT,
  Loading,
  Modal,
  message,
});
